import { Component } from 'react'
import { get as _get } from 'lodash'
import { Slider, SliderTrack, SliderFilledTrack, SliderThumb } from '@chakra-ui/react'
import { Box, Text, Button, Icons } from 'stylewhere/components'
import { Storage } from 'stylewhere/shared'
import { TmrRfidAntenna } from 'stylewhere/api'

type SliderSettingsProps = {
  title: string
  workstationId: string
  antenna: TmrRfidAntenna
  field: string
  min: number
  max: number
  step?: number
  onSliderChange?: (workstationId, antennaId: string, value: number) => void
}

interface State {
  sliderValue?: number
  hasLocalStorage: boolean
}

export class SliderSettings extends Component<SliderSettingsProps, State> {
  state: State = {
    sliderValue: undefined,
    hasLocalStorage: false
  }

  componentDidMount() {
    this._init()
  }

  getStorageKey = () => {
    const { workstationId, antenna, field } = this.props
    return `Settings-${workstationId}-${antenna.id}-${field}`
  }

  _init = async () => {
    const { antenna, field } = this.props
    const value = _get(antenna, field)

    const storageKey = this.getStorageKey()
    const userValue = await Storage.load(storageKey, undefined)

    this.setState({ sliderValue: userValue ?? value, hasLocalStorage: userValue !== undefined })
  }

  onChange = async (val) => {
    this.setState({ sliderValue: val })
  }

  onChangeEnd = async (val) => {
    const { onSliderChange, antenna, workstationId } = this.props

    const storageKey = this.getStorageKey()
    await Storage.save(storageKey, val)

    this.setState({ sliderValue: val, hasLocalStorage: true })

    onSliderChange && onSliderChange(workstationId, antenna.id, val)
  }

  reset = async () => {
    const storageKey = this.getStorageKey()
    await Storage.remove(storageKey)

    // set value to undefined for reset slider correctly
    this.setState({ sliderValue: undefined }, this.resetSliderValue)
  }

  resetSliderValue = () => {
    const { antenna, field } = this.props
    const value = _get(antenna, field)
    this.setState({ sliderValue: value, hasLocalStorage: false })
  }

  render() {
    const { title, min, max, step } = this.props
    const { sliderValue, hasLocalStorage } = this.state
    return (
      <Box flex row center mt={15} minheight={36}>
        <Text style={{ minWidth: 100 }}>{title}</Text>
        <Box flex ml={15}>
          {sliderValue !== undefined && (
            <Slider
              defaultValue={sliderValue}
              min={min}
              max={max}
              step={step !== undefined ? step : 1}
              onChange={(val) => this.onChange(val)}
              onChangeEnd={(val) => this.onChangeEnd(val)}
            >
              <SliderTrack bg="#dcdcdc">
                <SliderFilledTrack bg="#3182CE" />
              </SliderTrack>
              <SliderThumb boxSize={5} />
            </Slider>
          )}
        </Box>
        <Text
          style={{
            marginLeft: 20,
            backgroundColor: '#dcdcdc',
            borderRadius: 5,
            width: 50,
            textAlign: 'center',
            paddingTop: 3,
            paddingBottom: 3
          }}
        >
          {sliderValue}
        </Text>
        <Button
          style={{ marginLeft: 10 }}
          onClick={this.reset}
          variant="secondary"
          size="small"
          circle
          padding={'0px'}
          disabled={!hasLocalStorage}
        >
          <Icons.Delete width={16} height={16} />
        </Button>
      </Box>
    )
  }
}
